import { createSelector } from 'reselect';

// input: ['scenes', 'something', 'other'], state
// output: state.scenes.something.other
export function pathSelector(path, state) {
  return [state].concat(path).reduce(function (v, a) {
    return v[a];
  });
}

export function safePathSelector(path, state) {
  return [state].concat(path).reduce(function (v, a) {
    return (v || {})[a];
  });
}

// input: ['states', 'something', 'other'], ['key1', 'key2', 'key3'], { bla: 'asdf' }
// output: {
//   root: (state) => states.something.other,
//   key1: (state) => states.something.other.key1,
//   key2: (state) => states.something.other.key2,
//   key3: (state) => states.something.other.key3,
//   bla: 'asdf'
// }
export function createSelectors(path, keys) {
  var additional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var rootSelector = function rootSelector(state) {
    return pathSelector(path, state);
  };

  var selectors = {
    root: rootSelector
  };

  keys.forEach(function (key) {
    selectors[key] = createSelector(rootSelector, function (state) {
      return state[key];
    });
  });

  return Object.assign(selectors, additional);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/kea/es/kea/logic/selectors.js
// module id = 200
// module chunks = 0